import Design1 from "@public/svg/why-emenu/design1.svg"
import Design2 from "@public/svg/why-emenu/design2.svg"
import Design3 from "@public/svg/why-emenu/design3.svg"
import Journey1 from "@public/svg/why-emenu/journey1.svg"
import Journey2 from "@public/svg/why-emenu/journey2.svg"
import Journey3 from "@public/svg/why-emenu/journey3.svg"
import Journey4 from "@public/svg/why-emenu/journey4.svg"
import Journey5 from "@public/svg/why-emenu/journey5.svg"
import Journey6 from "@public/svg/why-emenu/journey6.svg"
import Sales1 from "@public/svg/why-emenu/sales1.svg"
import Sales2 from "@public/svg/why-emenu/sales2.svg"
import Sales3 from "@public/svg/why-emenu/sales3.svg"
import Sales4 from "@public/svg/why-emenu/sales4.svg"
import Sales5 from "@public/svg/why-emenu/sales5.svg"
import Sales6 from "@public/svg/why-emenu/sales6.svg"

export const StepsWhyDesign = [
  {
    title: "design_step_1",
    description: "design_step_1_text",
    icon: Design1,
  },
  {
    title: "design_step_2",
    description: "design_step_2_text",
    icon: Design2,
  },
  {
    title: "design_step_3",
    description: "design_step_3_text",
    icon: Design3,
  },
]

export const StepsWhyJourney = [
  {
    title: "journey_step_1",
    icon: Journey1,
  },
  {
    title: "journey_step_2",
    icon: Journey2,
  },
  {
    title: "journey_step_3",
    icon: Journey3,
  },
  {
    title: "journey_step_4",
    icon: Journey4,
  },
  {
    title: "journey_step_5",
    icon: Journey5,
  },
  {
    title: "journey_step_6",
    icon: Journey6,
  },
]

export const StepsWhySales = [
  {
    title: "sales_step_1",
    icon: Sales1,
  },
  {
    title: "sales_step_2",
    icon: Sales2,
  },
  {
    title: "sales_step_3",
    icon: Sales3,
  },
  {
    title: "sales_step_4",
    icon: Sales4,
  },
  {
    title: "sales_step_5",
    icon: Sales5,
  },
  {
    title: "sales_step_6",
    icon: Sales6,
  },
]
